import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { Box,Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function SlideDownModal({open,handleClickOpen,handleClose}) {
  const history = useHistory();
  return (
    <div>
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        Slide in alert dialog
      </Button> */}
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        PaperProps={{
            style: { borderRadius: 10, },
        }}
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Bagdogra Sectors"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
          <Grid container spacing={2}>
           {Array.from(Array(6)).map((i,index)=>{
            return  <Grid item xs={6} lg={3} >
            <Box style={{background:index===1?'rgb(238, 134, 35)':'rgb(15, 63, 90)',textAlign:'center',padding:8,cursor:'pointer'}} onClick={()=>history.push('/search')}>
            <span style={{textAlign:'center',color:'white',fontWeight:'bold'}}>IXD-DEL</span>
           </Box>
            </Grid>
           })}
          </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleClose}>Disagree</Button> */}
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}